<div class="space-y-8 animate-fade-in-up">

  <!-- 1. FILTERS       -->
 
  <div class="bg-white p-5 rounded-2xl shadow-sm border border-gray-100">
    <div class="flex flex-col md:flex-row flex-wrap gap-4 items-end">
      
      <!-- Firm -->
      <div class="flex flex-col gap-1.5 w-full md:w-48">
        <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Firm</label>
        <select class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all cursor-pointer">
          <option>All Firms</option>
          <option>Mumbai Branch</option>
          <option>Pune Branch</option>
        </select>
      </div>

      <!-- Period Toggles -->
      <div class="flex flex-col gap-1.5">
         <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">Period</label>
         <div class="flex rounded-lg border border-gray-200 overflow-hidden shadow-sm">
            <button class="px-6 py-2.5 bg-yellow-50 text-yellow-700 text-sm font-bold hover:bg-yellow-100 border-r border-gray-200 transition-colors">Today</button>
            <button class="px-6 py-2.5 bg-white text-gray-600 text-sm font-bold hover:bg-gray-50 border-r border-gray-200 transition-colors">Monthly</button>
            <button class="px-6 py-2.5 bg-white text-gray-600 text-sm font-bold hover:bg-gray-50 transition-colors">Yearly</button>
         </div>
      </div>

      <!-- Date From -->
      <div class="flex flex-col gap-1.5 w-full md:w-auto flex-1">
        <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">From</label>
        <input type="date" value="2025-12-01" class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
      </div>

      <!-- Date To -->
      <div class="flex flex-col gap-1.5 w-full md:w-auto flex-1">
        <label class="text-xs font-bold text-gray-500 uppercase tracking-wide">To</label>
        <input type="date" value="2025-12-08" class="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-yellow-500/20 focus:border-yellow-500 outline-none bg-white transition-all">
      </div>

      <!-- Submit Button -->
      <div class="flex flex-col gap-1.5">
        <button class="px-8 bg-gradient-to-r from-yellow-700 to-yellow-600 hover:from-yellow-800 text-white font-bold py-2.5 rounded-lg text-sm shadow-md transition-all uppercase tracking-wide">
          Submit
        </button>
      </div>

    </div>
  </div>

 
  <!-- MAIN GRID: 2 SECTIONS (ACCOUNTS VS UDHAR)               -->

  <div class="grid grid-cols-1 xl:grid-cols-2 gap-8">

    <!-- SECTION 1:  -->
    <div class="space-y-6">
       
       <!-- Header -->
       <div class="flex items-center gap-3 mb-2">
          <div class="h-8 w-1 bg-green-600 rounded-full"></div>
          <h2 class="text-xl font-bold text-gray-800">Financial Statements</h2>
       </div>

       <!--  Accounts Overview -->
       <div class="grid grid-cols-2 gap-4">
          <!-- Net Profit -->
          <div class="bg-gradient-to-br from-green-50 to-white p-6 rounded-2xl shadow-sm border border-green-100 relative overflow-hidden">
             <div class="absolute right-0 top-0 p-3 opacity-10 text-green-600"><span class="material-icons text-6xl">savings</span></div>
             <p class="text-xs font-bold text-green-700 uppercase tracking-widest mb-1">Net Profit</p>
             <h3 class="text-3xl font-extrabold text-gray-800">₹ 18,45,000</h3>
             <p class="text-[10px] text-green-600 font-bold mt-2">▲ 8.4% Growth</p>
          </div>
          <!-- Total Expenses -->
          <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
             <p class="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Total Expenses</p>
             <h3 class="text-3xl font-extrabold text-red-600">₹ 4,20,000</h3>
             <p class="text-[10px] text-gray-400 mt-2">Operating Cost</p>
          </div>
       </div>

       <!-- P&L and Balance Sheet -->
       <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          
          <!-- P&L Sheet Card -->
          <div routerLink="/profit-loss-sheet" class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 group hover:shadow-md transition cursor-pointer">
             <div class="flex justify-between items-start mb-4">
                <div class="p-3 bg-blue-50 text-blue-600 rounded-xl">
                   <span class="material-icons">analytics</span>
                </div>
                <span class="text-xs bg-gray-100 px-2 py-1 rounded text-gray-500">Live</span>
             </div>
             <h3 class="text-lg font-bold text-gray-800">Profit & Loss Sheet</h3>
             <p class="text-xs text-gray-400 mt-1 mb-4">View detailed income vs expense breakdown.</p>
             <button class="w-full py-2 border border-blue-100 text-blue-600 text-xs font-bold rounded-lg hover:bg-blue-50 transition">View Statement</button>
          </div>

          <!-- Balance Sheet Card -->
     
<div 
  routerLink="/balance-sheet"
  class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 group hover:shadow-md transition cursor-pointer"
>
  <div class="flex justify-between items-start mb-4">
      <div class="p-3 bg-purple-50 text-purple-600 rounded-xl">
         <span class="material-icons">account_balance</span>
      </div>
      <span class="text-xs bg-gray-100 px-2 py-1 rounded text-gray-500">FY 2025</span>
  </div>

  <h3 class="text-lg font-bold text-gray-800">Balance Sheet</h3>
  <p class="text-xs text-gray-400 mt-1 mb-4">Assets, Liabilities & Equity overview.</p>

  
  <button class="w-full py-2 border border-purple-100 text-purple-600 text-xs font-bold rounded-lg group-hover:bg-purple-50 transition">
    View Statement
  </button>
</div>

       </div>
    </div>


    <!-- SECTION 2: CREDIT MANAGEMENT (Udhar, List, Recovery) -->
    <div class="space-y-6">
       
       <!-- Header -->
       <div class="flex items-center gap-3 mb-2">
          <div class="h-8 w-1 bg-red-600 rounded-full"></div>
          <h2 class="text-xl font-bold text-gray-800">Credit (Udhar) Management</h2>
       </div>

       <!-- 2.1 Udhar Overview KPI -->
       <div class="bg-gradient-to-r from-red-50 to-white p-6 rounded-2xl shadow-sm border border-red-100 flex justify-between items-center">
          <div>
             <p class="text-xs font-bold text-red-700 uppercase tracking-widest mb-1">Total Market Udhar (Receivable)</p>
             <h3 class="text-4xl font-extrabold text-gray-800">₹ 8,50,000</h3>
          </div>
          <button class="h-12 w-12 bg-white rounded-full shadow-sm flex items-center justify-center text-red-600 hover:text-red-700 hover:shadow-md transition">
             <span class="material-icons">arrow_forward</span>
          </button>
       </div>

       <!-- Split View: Recovery Chart & List -->
       <div class="grid grid-cols-1 gap-6">
          
          <!-- Recovery Chart Area -->
          <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
             <div class="flex justify-between items-center mb-4">
                <h3 class="font-bold text-gray-800 flex items-center gap-2">
                   <span class="material-icons text-sm text-yellow-600">pie_chart</span> Recovery Chart
                </h3>
                <span class="text-xs font-bold text-green-600">65% Recovered</span>
             </div>
             
             <div class="flex items-center gap-4">
                <div class="h-4 w-full bg-gray-100 rounded-full overflow-hidden">
                   <div class="h-full bg-gradient-to-r from-green-500 to-green-400 w-[65%]"></div>
                </div>
             </div>
             <div class="flex justify-between text-xs text-gray-500 mt-2">
                <span>Recovered: ₹ 5.5L</span>
                <span>Pending: ₹ 3.0L</span>
             </div>
          </div>

          <!-- Udhar List -->
         <div class="bg-white p-0 rounded-2xl shadow-sm border border-gray-100 overflow-hidden h-full flex flex-col">
    <!-- Header -->
    <div class="p-4 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
       <h3 class="font-bold text-gray-800 flex items-center gap-2 text-sm">
           <span class="w-1 h-8 bg-red-500 rounded-full"></span> Udhar List (Top Debtors)
       </h3>
       <button routerLink="/udhar-list" class="text-[10px] font-bold text-red-600 bg-red-50 hover:bg-red-100 px-2 py-1 rounded border border-red-100 transition-colors uppercase tracking-wide">
           View All
       </button>
    </div>

    <!-- List Items -->
    <div class="divide-y divide-gray-50 flex-grow">
       <!-- Item 1 -->
       <div class="p-4 flex items-center justify-between hover:bg-red-50/30 transition cursor-pointer group">
          <div class="flex items-center gap-3">
             <div class="h-9 w-9 rounded-full bg-red-100 text-red-600 flex items-center justify-center font-bold text-xs border border-red-200">SJ</div>
             <div>
                <p class="text-sm font-bold text-gray-800 group-hover:text-red-600 transition-colors">Sharma Jewelers</p>
                <p class="text-[10px] text-red-500 font-medium">Overdue: 15 Days</p>
             </div>
          </div>
          <div class="text-right">
             <p class="text-sm font-bold text-gray-900">₹ 1.50L</p>
             <button class="text-[10px] text-blue-500 hover:text-blue-700 font-semibold">Remind 🔔</button>
          </div>
       </div>

       <!-- Item 2 -->
       <div class="p-4 flex items-center justify-between hover:bg-orange-50/30 transition cursor-pointer group">
          <div class="flex items-center gap-3">
             <div class="h-9 w-9 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center font-bold text-xs border border-orange-200">VB</div>
             <div>
                <p class="text-sm font-bold text-gray-800 group-hover:text-orange-600 transition-colors">Verma Brothers</p>
                <p class="text-[10px] text-orange-500 font-medium">Due in: 2 Days</p>
             </div>
          </div>
          <div class="text-right">
             <p class="text-sm font-bold text-gray-900">₹ 0.80L</p>
             <button class="text-[10px] text-blue-500 hover:text-blue-700 font-semibold">Remind 🔔</button>
          </div>
       </div>
    </div>
 </div>

       </div>
    </div>

  </div>

</div>